import React, { useEffect, useState } from "react";
import { Button, Input, message, Select, Form, Image } from "antd";
import { authSVC } from "../../services";
import { Option } from "antd/es/mentions";
import { useB2BContext } from "../../context/ContextB2B";
import "./AddEmployees.scss";
  import { useNavigate, useLocation } from "react-router-dom";


interface Contentdata {
  _id: string;
  full_name: string;
  email: string;
  user_type: string;
  company: string;
  department: string;
  occupation: string;
  marital_Status: string;
  package_id: string;
  company_id: string;
  package_name: string;
  gender: string;
}

function AddEmployees() {
  const [form] = Form.useForm();
  const { getUserByID } = useB2BContext();

  const [editContent, setEditContent] = useState<Contentdata>({
    _id: "", full_name: "", email: "", user_type: "",
    company: "", department: "", occupation: "",
    package_id: "", company_id: "", package_name: "",
    marital_Status: "", gender: "",
  });

  const [contentData, setContentData] = useState<any[]>([]);
  const [loading, setloading] = useState<boolean>(false);
  const [disableAddBtn, setDisableAddBtn] = useState(false);
  const [disableAddEmp, setDisableAddEmp] = useState(false);
  const [userPackage, setUserPackage] = useState("");
  const [allDepartments, setAllDepartments] = useState<any>();
  const [packageList, setPackageList] = useState([]);
    const navigate = useNavigate();


  useEffect(() => { getDepartments(getUserByID); }, [getUserByID]);
  useEffect(() => { setUserPackage(getUserByID?.package_name); }, [getUserByID]);
  useEffect(() => { setPackageList(getUserByID?.company_id?.package); }, [getUserByID]);

  useEffect(() => {
    if (getUserByID?.email) {
      authSVC.getCompanyuser()
        .then((res: any) => setContentData(res.data?.data))
        .catch((err: any) => message.error(err.message));
    }
  }, [getUserByID?.email]);

  console.log(getUserByID,"getUserByID");
  

  const getDepartments = (getUserByID: any) => {
    if (getUserByID?.company) {
      authSVC.getCompanyDepartments(getUserByID?.company)
        .then((res: any) => setAllDepartments(res.data))
        .catch((err: any) => message.error(err.message));
    }
  };

  const addEmployees = () => {
    setloading(true);
    authSVC.adduser({
      full_name: editContent.full_name,
      email: editContent.email,
      user_type: "Company_member",
      company: getUserByID?.company,
      adminId: getUserByID?._id,
      department: editContent?.department,
      occupation: editContent.occupation,
      marital_Status: editContent.marital_Status,
      package_id: editContent.package_id,
      company_id: getUserByID?.company_id?._id,
      package_name: editContent.package_name,
      gender: editContent.gender,
    })
      .then(() => {
        setloading(false);
          navigate("/manage_exployees");
        message.success("Employee added successfully!");
        form.resetFields();
      })
      .catch((err: any) => {
        message.error(err.response?.data?.error);
        setloading(false);
      });
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setEditContent((prev: any) => ({ ...prev, [name]: value }));
    form.setFieldsValue({ [name]: value });
    form.validateFields([name]);
  };

  const handleSelectedItem = (value: any) => {
    setDisableAddEmp(false);
    setEditContent((prev: any) => ({ ...prev, user_type: value }));
  };

  const handleSelectedMarital = (value: any) => {
    setDisableAddEmp(false);
    setEditContent((prev: any) => ({ ...prev, marital_Status: value }));
  };

  const handleSelectedGender = (value: any) => {
    setDisableAddEmp(false);
    setEditContent((prev: any) => ({ ...prev, gender: value }));
  };

  const handleSelectedDepratment = (value: any) => {
    if (value) setDisableAddEmp(false);
    setEditContent((prev: any) => ({ ...prev, department: value }));
  };

  const handleSelectedPackage = (packageValue: any) => {
    const value = JSON.parse(packageValue);
    if (value) {
      setDisableAddEmp(false);
      setEditContent((prev: any) => ({
        ...prev,
        package_id: value._id,
        package_name: value.package,
      }));
    }
  };

  const filteredContents = contentData?.filter(
    (item: any) => item?.email !== getUserByID?.email
  );

  useEffect(() => {
    if (filteredContents?.length === 10 && userPackage === "Gold") setDisableAddBtn(true);
    else if (filteredContents?.length === 100 && userPackage === "Diamond") setDisableAddBtn(true);
    else if (filteredContents?.length >= 100 && userPackage === "Platinum") setDisableAddBtn(true);
    else setDisableAddBtn(false);
  }, [filteredContents, userPackage]);

  useEffect(() => {
    if (allDepartments?.message?.length === 0) setDisableAddEmp(true);
    else setDisableAddEmp(false);
  }, [allDepartments]);

  const onFinish = () => {
    if (editContent.department === "") {
      setDisableAddEmp(true);
      message.info("Please select a department");
    } else if (editContent.user_type === "") {
      message.info("Please select user type");
      setDisableAddEmp(true);
    } else {
      addEmployees();
    }
  };

  const nameValidation = (_: any, value: any) => {
    const regex = /^[A-Za-z\s]+$/;
    if (!value || regex.test(value)) return Promise.resolve();
    return Promise.reject(new Error("Please enter a valid name with only letters."));
  };

  // Step progress tracking — only count a field once it holds *valid* data,
  // not just any truthy value (e.g. a name that fails the letters-only rule).
  const isNameValid = editContent.full_name.trim() !== "" && /^[A-Za-z\s]+$/.test(editContent.full_name);
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editContent.email);

  const filledCount = [
    editContent.package_name,
    isNameValid,
    isEmailValid,
    editContent.occupation,
    editContent.marital_Status,
    editContent.gender,
    editContent.department,
    editContent.user_type,
  ].filter(Boolean).length;
  const totalFields = 8;
  const progressPct = Math.round((filledCount / totalFields) * 100);

  return (
    <div className="add-emp">
      {/* Header */}
      <div className="add-emp__header">
        <div className="add-emp__header-text">
          <button
            type="button"
            className="add-emp__back"
            onClick={() => navigate("/manage_exployees")}
          >
            ← Back to Employees
          </button>
          <h1 className="add-emp__title">Add Employee</h1>
          <p className="add-emp__subtitle">Fill in the details to invite a new team member.</p>
        </div>
        <div className="add-emp__progress-ring">
          <svg viewBox="0 0 44 44" className="add-emp__ring-svg">
            <circle cx="22" cy="22" r="18" className="add-emp__ring-bg" />
            <circle
              cx="22" cy="22" r="18"
              className="add-emp__ring-fill"
              strokeDasharray={`${(progressPct / 100) * 113} 113`}
            />
          </svg>
          <span className="add-emp__ring-label">{progressPct}%</span>
        </div>
      </div>

      {/* No-dept warning banner */}
      {disableAddEmp && (
        <div className="add-emp__warning">
          <span className="add-emp__warning-icon">⚠️</span>
          <span>
            No departments found. Please{" "}
            <strong>create a department</strong> before adding employees.
          </span>
        </div>
      )}

      <Form
        name="add_employee"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        form={form}
        className="add-emp__form"
      >
        {/* ── Package ───────────────────────────────────── */}
        <div className="add-emp__field-group">
          <label className="add-emp__label" htmlFor="add_employee_selected_package">
            <span className="add-emp__label-icon">📦</span>
            Employee Package
          </label>
          <Form.Item
            name="selected_package"
            rules={[{ required: true, message: "Please select employee package!" }]}
          >
            <Select
              placeholder="Select a package"
              onChange={handleSelectedPackage}
              className="add-emp__select"
            >
              {packageList?.map((packageDetail: any) => (
                <Option
                  key={packageDetail.package_id._id}
                  value={JSON.stringify(packageDetail.package_id)}
                >
                  {packageDetail.package_id.package}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>

        {/* ── Divider ───────────────────────────────────── */}
        <p className="add-emp__section-label">Personal Details</p>

        {/* ── Full name ─────────────────────────────────── */}
        <div className="add-emp__field-group">
          <label className="add-emp__label" htmlFor="add_employee_full_name">
            <span className="add-emp__label-icon">👤</span>
            Full Name
          </label>
          <Form.Item
            name="full_name"
            rules={[
              { required: true, message: "Please enter employee full name!" },
              { validator: nameValidation },
            ]}
          >
            <Input
              name="full_name"
              className="add-emp__input"
              value={editContent?.full_name}
              onChange={handleInputChange}
              type="text"
              placeholder="e.g. Priya Sharma"
            />
          </Form.Item>
        </div>

        {/* ── Email ─────────────────────────────────────── */}
        <div className="add-emp__field-group">
          <label className="add-emp__label" htmlFor="add_employee_email">
            <span className="add-emp__label-icon">✉️</span>
            Work Email
          </label>
          <Form.Item
            name="email"
            rules={[{ required: true, type: "email", message: "Please enter a valid email!" }]}
          >
            <Input
              className="add-emp__input"
              name="email"
              onChange={handleInputChange}
              value={editContent.email}
              placeholder="employee@company.com"
            />
          </Form.Item>
        </div>

        {/* ── Occupation ────────────────────────────────── */}
        <div className="add-emp__field-group">
          <label className="add-emp__label" htmlFor="add_employee_occupation">
            <span className="add-emp__label-icon">💼</span>
            Occupation
          </label>
          <Form.Item
            name="occupation"
            rules={[{ required: true, message: "Please enter occupation" }]}
          >
            <Input
              className="add-emp__input"
              name="occupation"
              placeholder="e.g. Software Engineer"
              onChange={handleInputChange}
            />
          </Form.Item>
        </div>

        {/* ── Two-col row: Marital + Gender ─────────────── */}
        <p className="add-emp__section-label">Demographics</p>
        <p className="add-emp__field-hint">
          Optional. Used only to personalise wellness recommendations — never shared outside the wellness platform.
        </p>

        <div className="add-emp__two-col">
          <div className="add-emp__field-group">
            <label className="add-emp__label" htmlFor="add_employee_marital_Status">Marital Status (optional)</label>
            <Form.Item name="marital_Status">
              <Select
                placeholder="Select status"
                onChange={handleSelectedMarital}
                className="add-emp__select"
                allowClear
              >
                <Option value="Married">Married</Option>
                <Option value="UnMarried">Unmarried</Option>
              </Select>
            </Form.Item>
          </div>

          <div className="add-emp__field-group">
            <label className="add-emp__label" htmlFor="add_employee_gender">Gender (optional)</label>
            <Form.Item name="gender">
              <Select
                placeholder="Select gender"
                onChange={handleSelectedGender}
                className="add-emp__select"
                allowClear
              >
                <Option value="Male">Male</Option>
                <Option value="Female">Female</Option>
                <Option value="Other">Other</Option>
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* ── Two-col row: Department + User Type ───────── */}
        <p className="add-emp__section-label">Organization</p>

        <div className="add-emp__two-col">
          <div className="add-emp__field-group">
            <label className="add-emp__label" htmlFor="add_employee_department">Department</label>
            <Form.Item name="department">
              <Select
                placeholder="Select department"
                onChange={handleSelectedDepratment}
                className="add-emp__select"
              >
                {allDepartments?.data?.map((item: any, index: any) => (
                  <Option value={item.name} key={index}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div className="add-emp__field-group">
            <label className="add-emp__label" htmlFor="add_employee_user_type">User Type</label>
            <Form.Item name="user_type">
              <Select
                placeholder="Select type"
                onChange={handleSelectedItem}
                className="add-emp__select"
              >
                <Option value="Company_member">Company Member</Option>
              </Select>
            </Form.Item>
          </div>
        </div>

        {/* ── Info note ─────────────────────────────────── */}
        <div className="add-emp__info-note">
          <span className="add-emp__info-icon">ℹ️</span>
          <p>
            The employee will receive an invitation email with a secure link to set
            their own password. Contact support if any issues arise.
          </p>
        </div>

        {/* ── Submit ────────────────────────────────────── */}
        <Button
          className="add-emp__submit"
          htmlType="submit"
          loading={loading}
          disabled={disableAddEmp || disableAddBtn}
          icon={<Image src="/img/new/add.svg" preview={false} alt="" />}
        >
          Add Employee
        </Button>

        {disableAddBtn && (
          <p className="add-emp__limit-msg">
            You've reached the employee limit for your <strong>{userPackage}</strong> plan.
            Please upgrade to add more employees.
          </p>
        )}
      </Form>
    </div>
  );
}

export default AddEmployees;